import React from 'react'
import styled from 'styled-components'
import { device } from "../device"

const Title = styled.h2`
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2;

    @media ${device.lg} {
        font-size: 48px;
    }
`;

export default React.memo(Title);